import { render, staticRenderFns } from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=template&id=869293f2&scoped=true"
import script from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js"
export * from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTargetPreferredObjectStorePopover.vue?vue&type=style&index=0&id=869293f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869293f2",
  null
  
)

export default component.exports